module.exports = __webpack_public_path__ + "static/media/next-page.b6b6c4db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/next-page.svg
// module id = 853
// module chunks = 0